import { observer } from 'mobx-react-lite';
import { Sun, MoonStars } from '@phosphor-icons/react';
import { useResolve } from '@/infrastructure/useResolve';
import { TOKEN_II18n } from '@/services/i18n/I18n';
import { TOKEN_ThemeStore } from './ThemeStore';

export const ThemeToggleView = observer(function ThemeToggleView() {
  const store = useResolve(TOKEN_ThemeStore);
  const i18n = useResolve(TOKEN_II18n);
  return (
    <button
      type="button"
      onClick={store.toggle}
      className="flex h-9 w-9 items-center justify-center rounded-full text-muted transition-colors hover:bg-line/60 hover:text-ink"
      title={i18n.t('theme.toggle')}
      aria-label={i18n.t('theme.toggle')}
    >
      {store.isDark ? <Sun size={18} weight="duotone" /> : <MoonStars size={18} weight="duotone" />}
    </button>
  );
});
